import { css } from '@emotion/react';
import AddIcon from '@mui/icons-material/Add';
import { Box, Button } from '@mui/material';
import { useAtomValue } from 'jotai';
import { useMemo } from 'react';
import { Link } from 'react-router';
import { ROUTES } from '../../../../../constants/RouteNameMapping';
import { ContainerName } from '../../../../../constants/styles';
import { getPlainDateString } from '../../../../../services/queries/MaggieMetricsQueries';
import {
  mostRecentRubricsByCompanyIdAtom,
  rubricConfigAtom,
} from '../../../../../services/state/RubricsStateJ';
import { HelpMessage } from '../../../components/Messages/HelpMessage';
import { selectedMetricsDateCPState } from '../../../state/CompanyFinancialsDateState';
import { SubSection } from '../../../Summary/components/SubSection';
import { RubricList } from './RubricList';

const RubricsContainer = css`
  container-name: ${ContainerName.rubricSectionContainer};
  container-type: inline-size;
`;

interface IRubricSectionProps {
  companyId: number;
}
export function RubricSection({ companyId }: IRubricSectionProps) {
  const config = useAtomValue(rubricConfigAtom);
  const date = useAtomValue(selectedMetricsDateCPState(companyId));
  const { data: rubrics } = useAtomValue(
    mostRecentRubricsByCompanyIdAtom({ companyId, date: getPlainDateString(date) })
  );
  const sortedRubrics = useMemo(() => {
    return [...rubrics].sort((a, b) => {
      const aTime = a.createdAt ? new Date(a.createdAt).getTime() : 0;
      const bTime = b.createdAt ? new Date(b.createdAt).getTime() : 0;
      return aTime - bTime;
    });
  }, [rubrics]);

  return (
    <SubSection
      title={'Performance Assessment'}
      collapseProps={{ collapsible: true, defaultExpanded: true }}
      key={`${companyId}-${getPlainDateString(date)}`}
    >
      <div css={RubricsContainer}>
        {config?.length ? <RubricList companyId={companyId} rubrics={sortedRubrics} /> : <NoRubricsMessage />}
      </div>
    </SubSection>
  );
}

function NoRubricsMessage() {
  return (
    <Box>
      <HelpMessage severity='info' message='No rubrics exist.' />
      <Button
        variant='outlined'
        color='secondary'
        endIcon={<AddIcon />}
        component={Link}
        to={`/${ROUTES.ADMIN_PANEL}/${ROUTES.ADMIN_PANEL_RUBRICS}`}
        style={{ marginTop: '1rem' }}
      >
        Create rubric
      </Button>
    </Box>
  );
}
